import { render, staticRenderFns } from "./Drone.vue?vue&type=template&id=b745fa24&scoped=true&"
import script from "./Drone.vue?vue&type=script&lang=js&"
export * from "./Drone.vue?vue&type=script&lang=js&"
import style0 from "./Drone.vue?vue&type=style&index=0&id=b745fa24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b745fa24",
  null
  
)

export default component.exports